const getters = {
  userInfo: state => state.user.userInfo,
  currentTab: state => state.mistakes.currentTab,
  activeSub: state => state.mistakes.activeSub
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js